import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replace'
})
export class ReplacePipe implements PipeTransform {

  transform(value: string, pattern: any, replacement: any): string {
    return value?.replace(pattern, replacement);
  }

}
